import { on } from 'delegated-events'
import Swiper, { Autoplay, EffectFade } from 'swiper'
import scrollTo from '../common/scrollTo'

Swiper.use([Autoplay, EffectFade])

const fn = {
  init: () => {
    on('scrolldropdownchange', 'html', fn.handleAccordion)
    document.querySelectorAll('.usergroup-testimonials-slider').forEach((el) => fn.setupSlider(el))
    fn.handleAccordion()
  },

  handleAccordion: (e) => {
    let section = null

    if (e && e.detail.value) {
      section = document.querySelector(e.detail.value)
    } else if (window.location.hash) {
      const hashTarget = document.querySelector(window.location.hash)

      if (hashTarget) {
        section = hashTarget
      }
    }

    if (section) {
      const el = section.querySelector('[data-slide-toggle]')

      if (el) {
        const trigger = el.closest('[data-slide-toggle]')
        const target = document.getElementById(trigger.getAttribute('aria-controls'))

        if (trigger && target) {
          trigger.setAttribute('aria-expanded', 'true')
          trigger.parentNode.classList.add('is-active')
          target.classList.remove('hidden')
          target.style.display = null

          const otherTriggers = Array.from(
            document.querySelectorAll('[data-slide-toggle][aria-expanded="true"]')
          ).filter((x) => x !== trigger)

          if (otherTriggers.length) {
            otherTriggers.forEach((el) => {
              const otherTrigger = el
              const otherTarget = document.getElementById(otherTrigger.getAttribute('aria-controls'))

              otherTrigger.setAttribute('aria-expanded', 'false')
              otherTrigger.parentNode.classList.remove('is-active')
              otherTarget.classList.add('hidden')
              otherTarget.style.display = null
            })
          }
        }
      }

      scrollTo(section)
    }
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      new Swiper(container, {
        autoplay: {
          delay: 6000,
        },
        slidesPerView: 1,
        speed: 750,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      })
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-usergrouppage'),
  run: fn.init,
}
